/**
 * Semantic accent keys for portal UI colorization.
 * CSS maps each key via [data-accent="…"] → --ui-accent.
 */
export const UI_ACCENT = {
  dashboard: "dashboard",
  students: "students",
  teachers: "teachers",
  guardians: "guardians",
  notes: "notes",
  reports: "reports",
  calls: "calls",
  feeds: "feeds",
  classes: "classes",
  periods: "periods",
  todos: "todos",
  settings: "settings",
  flag: "flag",
  library: "library",
  gallery: "gallery",
  training: "training",
  classroom: "classroom",
};

const PATH_ACCENTS = {
  "/dashboard": UI_ACCENT.dashboard,
  "/feeds": UI_ACCENT.feeds,
  "/student-reports": UI_ACCENT.reports,
  "/reported-feeds": UI_ACCENT.flag,
  "/class-room": UI_ACCENT.classroom,
  "/class-calls": UI_ACCENT.calls,
  "/classes": UI_ACCENT.classes,
  "/subjects": UI_ACCENT.classes,
  "/class-periods": UI_ACCENT.periods,
  "/lesson-books": UI_ACCENT.gallery,
  "/training-lesson": UI_ACCENT.training,
  "/students": UI_ACCENT.students,
  "/teachers": UI_ACCENT.teachers,
  "/guardians": UI_ACCENT.guardians,
  "/personal-notes": UI_ACCENT.notes,
  "/to-do-lists": UI_ACCENT.todos,
  "/general-setting": UI_ACCENT.settings,
  "/library/categories": UI_ACCENT.library,
  "/library/books": UI_ACCENT.library,
};

const KEY_ALIASES = {
  "personal-notes": UI_ACCENT.notes,
  "student-reports": UI_ACCENT.reports,
  "reported-feeds": UI_ACCENT.flag,
  "class-calls": UI_ACCENT.calls,
  "class-periods": UI_ACCENT.periods,
  "class-room": UI_ACCENT.classroom,
  "lesson-books": UI_ACCENT.gallery,
  "training-lesson": UI_ACCENT.training,
  "library-categories": UI_ACCENT.library,
  "library-books": UI_ACCENT.library,
  "to-do-lists": UI_ACCENT.todos,
  "general-setting": UI_ACCENT.settings,
  recent_reports: UI_ACCENT.reports,
  recent_students: UI_ACCENT.students,
  recent_calls: UI_ACCENT.calls,
  recent_feeds: UI_ACCENT.feeds,
};

/** Resolve a config key or route path to a known accent (falls back to theme via CSS). */
export function resolveUiAccent(key) {
  if (!key) return undefined;
  const raw = String(key).trim();
  if (PATH_ACCENTS[raw]) return PATH_ACCENTS[raw];

  const normalized = raw.toLowerCase().replace(/_/g, "-").replace(/^\//, "");
  if (PATH_ACCENTS[`/${normalized}`]) return PATH_ACCENTS[`/${normalized}`];
  if (KEY_ALIASES[normalized] || KEY_ALIASES[raw]) {
    return KEY_ALIASES[normalized] || KEY_ALIASES[raw];
  }
  if (Object.values(UI_ACCENT).includes(normalized)) return normalized;
  if (Object.values(UI_ACCENT).includes(raw)) return raw;
  return undefined;
}
